export default __webpack_public_path__ + "static/media/img_030.a95a57a3.jpg";